import { Menu, LogOut, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { ROLES } from '../../utils/constants';

export default function Topbar({ onMenuClick }) {
  const { user, logout } = useAuth();

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 md:px-6">
      <button onClick={onMenuClick} className="p-2 rounded-lg hover:bg-gray-100 md:hidden min-h-[44px] min-w-[44px] flex items-center justify-center">
        <Menu className="w-5 h-5" />
      </button>
      <div className="hidden md:block">
        <h1 className="text-lg font-semibold text-gray-800">YSRCP Cadre Management</h1>
      </div>
      <div className="flex items-center gap-3">
        <div className="hidden sm:block text-right">
          <div className="text-sm font-medium text-gray-800">{user?.name}</div>
          <div className="text-xs text-gray-500">{ROLES[user?.role] || user?.role}</div>
        </div>
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-teal-400 to-blue-600 flex items-center justify-center">
          <User className="w-4 h-4 text-white" />
        </div>
        <button
          onClick={logout}
          className="p-2 rounded-lg hover:bg-gray-100 text-gray-500 min-h-[44px] min-w-[44px] flex items-center justify-center"
          title="Logout"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}
